import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconSettings: React.FC<IconProps> = ({ width = 20, height = 20, color = '#7f7f7f' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
        >
            <g clip-path="url(#clip0_11498_31755)">
                <path
                    d="M10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875C8.27411 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125Z"
                    stroke={color}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M10.1588 16.1023C10.0541 16.1023 9.94865 16.1023 9.8463 16.1023L7.3424 17.5C6.36765 17.1721 5.46355 16.6632 4.67755 16L4.66818 13.1875C4.61271 13.1 4.56037 13.0117 4.51193 12.9211L2.02209 11.5031C1.82597 10.5112 1.82597 9.4904 2.02209 8.49844L4.50959 7.08438C4.56037 6.99453 4.61271 6.90547 4.66584 6.81797L4.67834 4.00547C5.46362 3.34035 6.36749 2.82957 7.3424 2.5L9.8424 3.89766C9.94709 3.89766 10.0526 3.89766 10.1549 3.89766L12.6549 2.5C13.6296 2.82788 14.5337 3.33679 15.3197 4L15.3291 6.8125C15.3846 6.9 15.4369 6.98828 15.4854 7.07891L17.9736 8.49609C18.1698 9.48806 18.1698 10.5088 17.9736 11.5008L15.4861 12.9148C15.4354 13.0047 15.383 13.0938 15.3299 13.1813L15.3174 15.9938C14.5326 16.659 13.6293 17.17 12.6549 17.5L10.1588 16.1023Z"
                    stroke={color}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_11498_31755">
                    <rect width="20" height="20" fill={color} />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconSettings;
